import { User } from '@/model/user.ts'

export class LoginResponse {
  readonly sessionToken: string
  readonly user: User

  constructor (sessionToken: string, user: User) {
    this.sessionToken = sessionToken
    this.user = user
  }

  static fromJson (data: any): LoginResponse {
    return new LoginResponse(
      data.sessionToken || data.session_token,
      User.fromJson(data.user),
    )
  }
}
